import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";

const ABOUT_IMAGE = "https://images.unsplash.com/photo-1758972581344-85dd3ccb10db?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export const AboutSection = () => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" ref={ref} className="py-16 sm:py-20 lg:py-28 bg-gray-50" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -30 }} 
            animate={isVisible ? { opacity: 1, x: 0 } : {}} 
            transition={{ duration: 0.6 }} 
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-lg">
              <img src={ABOUT_IMAGE} alt="Beautiful Interior Design" className="w-full h-64 sm:h-80 lg:h-[450px] object-cover" />
            </div>
            <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 bg-white rounded-xl sm:rounded-2xl shadow-lg p-4 sm:p-5">
              <p className="text-3xl sm:text-4xl font-bold text-purple-600">8+</p>
              <p className="text-xs sm:text-sm text-gray-600">Years of Excellence</p>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 30 }} 
            animate={isVisible ? { opacity: 1, x: 0 } : {}} 
            transition={{ duration: 0.6, delay: 0.15 }} 
            className="space-y-4 sm:space-y-5"
          >
            <span className="text-purple-600 font-semibold tracking-wider uppercase text-xs sm:text-sm">About Us</span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
              Your Trusted Partner in
              <span className="text-purple-600 block">Beautiful Spaces</span>
            </h2>
            <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
              Established in <strong>2017</strong>, Sri Pavanasutha Traders has been the go-to destination 
              for premium paints and wall finishes in Godavarikhani. Under the expert guidance of 
              <strong> Proprietor B. Anil Kumar</strong>, we have helped thousands of customers 
              transform their homes and businesses.
            </p>
            <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
              As authorized dealers of <strong>Asian Paints Colour World</strong>, <strong>Nexon Paints</strong>, 
              and <strong>Birla Opus</strong>, we bring you the finest quality products with expert 
              consultation and competitive pricing.
            </p>

            <div className="grid grid-cols-2 gap-3 sm:gap-4 pt-4">
              <div className="p-3 sm:p-4 bg-white rounded-xl shadow-sm border border-gray-100">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-2 sm:mb-3">
                  <span className="text-xl sm:text-2xl">🏆</span>
                </div>
                <h4 className="font-semibold text-gray-900 text-sm sm:text-base">Premium Quality</h4>
                <p className="text-xs sm:text-sm text-gray-500">Only the best brands</p>
              </div>
              <div className="p-3 sm:p-4 bg-white rounded-xl shadow-sm border border-gray-100">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-2 sm:mb-3">
                  <span className="text-xl sm:text-2xl">💡</span>
                </div>
                <h4 className="font-semibold text-gray-900 text-sm sm:text-base">Expert Advice</h4>
                <p className="text-xs sm:text-sm text-gray-500">Color consultation</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
